import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {HolidayPanel} from "@/scenes.ui/holiday-panel";
import {Creature} from "@/store/level/types";
import {Keys} from "@/constants/key";
import {SquareButton} from "@/scenes.ui/square-button";
import SpriteUtils from "@/utils/sprite-utils";
import {BoosterDto, BoostersDto} from "@/store/shop/types";
import BoosterUtils from "@/utils/booster-utils";

export class NewBoosterPanel extends HolidayPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, dto:BoosterDto) {
        super(scene, canvas, Tr( 'c.boosters'));
        this.setDepth(20000);
        this.background.setAlpha(0.01);


        let mainText = TextUtils.addTextByFamily(scene, dto.name.toUpperCase(),
            0, 10, '#ffc536', 21, 'normal', 380, Fonts.BENGALY_NORMAL);

        let activeTill = TextUtils.addTextByFamily(scene, Tr('act.till') + dto.validTill,
            0, 45, '#78ff46', 18, 'normal', 380, Fonts.BENGALY_NORMAL);

        let light = SpriteUtils.addSprite(this.scene!, 0, -90, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT, 4, 2);

        let boosterPicture = SpriteUtils.addSprite(this.scene!, 0, -100, Keys.ATLAS_PROFILE, Keys.UI_SQUARE_FRAME );

        scene.load.image( Keys.ATLAS_BOOST, BoosterUtils.getIcon(dto.boosterType));
        scene.load.once(Phaser.Loader.Events.COMPLETE, () => {
            SpriteUtils.setSprite(scene, boosterPicture,  Keys.ATLAS_BOOST, BoosterUtils.getIcon(dto.boosterType));
        });
        scene.load.start();

        let okButton = new SquareButton(this.scene, 0, 150, 0,
            Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('otlichno').toUpperCase(), false);

        let self = this;
        okButton.setCallback(() => {
            if (this.isOnTop()) {
                self.close();
            }
        });

        this.add([light, mainText, activeTill, boosterPicture, okButton]);
    }

}
